<template>
    <side-drawer
        :open="open"
        :title="titleText"
        icon="ni-filter-fill"
        :size="resolvedSize"
        overlay-class="sip-filter-sheet-overlay"
        drawer-class="sip-filter-sheet"
        :close-label="trans('general.cancel')"
        @close="close"
    >
        <div class="sip-filter-sheet-fields">
            <slot></slot>
        </div>
        <template #footer v-if="showApply || showReset || $slots.footer">
            <slot name="footer">
                <button
                    v-if="showReset"
                    type="button"
                    class="btn sip-filter-sheet-reset"
                    @click="reset"
                >
                    {{ resetText }}
                </button>
                <button
                    v-if="showApply"
                    type="button"
                    class="btn btn-primary sip-filter-sheet-apply"
                    @click="apply"
                >
                    <em class="icon ni ni-check-circle me-1"></em> {{ applyText }}
                </button>
            </slot>
        </template>
    </side-drawer>
</template>

<script>
    import sideDrawer from './side-drawer'

    export default {
        name: 'filter-sheet',
        components: { sideDrawer },
        props: {
            open: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            applyLabel: {
                type: String,
                default: ''
            },
            resetLabel: {
                type: String,
                default: ''
            },
            showApply: {
                type: Boolean,
                default: true
            },
            showReset: {
                type: Boolean,
                default: true
            },
            size: {
                type: String,
                default: ''
            }
        },
        computed: {
            titleText() {
                return this.title || this.trans('general.filter');
            },
            applyText() {
                return this.applyLabel || this.trans('general.filter');
            },
            resetText() {
                return this.resetLabel || this.trans('general.reset');
            },
            resolvedSize() {
                if (this.size === 'lg' || this.size === 'xl') {
                    return this.size;
                }
                if (this.size === 'sm' || this.size === 'md') {
                    return this.size;
                }
                return 'md';
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            apply() {
                this.$emit('apply');
                this.$emit('close');
            },
            reset() {
                this.$emit('reset');
            }
        }
    }
</script>
